<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customBtns="customBtns"
    titleKey="locales.name"
    orderBy="sequence"
    orderWay="asc"
  >
  </WsRead>
</template>

<script>
import model from "@/models/industry_category";
export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      localeMode: true,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                fields: ["locales"],
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "設定",
                fields: ["sequence", "area"],
              },
            ],
          },
        ],
      },
      customBtns: [
        {
          title: `查看子產業類別`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-eye",
          to: `${this.$route.params.id}/industry_categories`,
        },
        {
          title: `編輯子產業類別`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-pencil",
          to: `${this.$route.params.id}/industry_categories/update`,
        },
      ]
    }
  },
};
</script>